// extracted by mini-css-extract-plugin
export default {"changeLogs":"StatusChangeLogs_changeLogs__7YG0L"};